import React from "react";
import PropTypes from 'prop-types';
import SelectDataTable from '../form/SelectDataTable';
import BillingAccountColumn from '../../../shared/component/dataTable/columns/BillingAccountColumn';
import BillingAccountService from "../../../shared/service/BillingAccountService";

export default class BillingAccountGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            validate: this.props.validate,
            dataTable: this.props.dataTable,
            disabled: this.props.disabled,
            label : this.props.label
        };
        this.service = new BillingAccountService();
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            validate: nextProps.validate,
            value: nextProps.value,
            dataTable: nextProps.dataTable,
            label: nextProps.label,
            disabled: nextProps.disabled,
        });
    }

    render() {
        let validate = this.state.validate;
        if (!validate) {
            validate = {
                required: {
                    value: true,
                    errorMessage: "Bu alanın doldurulması zorunludur."
                }
            };
        }

        let label = this.state.label;
        if (!label) {
            label = "Fatura Hesabı Adı"
        }


        let dataTable = this.state.dataTable;
        if (!dataTable) {
            dataTable = {
                dataURL : "billingAccount/findAll",
                fields: BillingAccountColumn.fields
            };
        }
        return (
            <SelectDataTable
                value={this.state.value}
                validate={validate}
                dataTable={dataTable}
                disabled={this.state.disabled}
                name="billingAccount"
                translateKey="billing-account.name"
                label={label}
                dialogHeader="Fatura Hesabı Listesi"
                onDataSelect={this.props.onDataSelect}
                autoRefrestData={this.props.autoRefrestData ? this.props.autoRefrestData : false}
            />
        );
    }
}
BillingAccountGroup.propTypes = {
    value: PropTypes.string,
    validate: PropTypes.object,
    dataTable: PropTypes.object
}